import React from 'react';
import { VsPageLayout } from '../components/VsPageLayout';
export function VsHubspot() {
  return <VsPageLayout competitorName="HubSpot" competitorDescription="HubSpot is a CRM and marketing platform for sales and marketing teams." seoTitle="MindStream.ing vs HubSpot — AI That Runs More Than Just Your CRM" comparisonRows={[{
    feature: 'AI runs everything (not just CRM)',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Voice AI',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Self-managing (no manual entry)',
    mistr: '✅',
    competitor: '❌ (manual)'
  }, {
    feature: 'Project management',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'Website management',
    mistr: '✅',
    competitor: 'HubSpot CMS only'
  }, {
    feature: 'PPC campaign management',
    mistr: '✅',
    competitor: 'HubSpot Ads add-on'
  }, {
    feature: 'Auto follow-ups from any channel',
    mistr: '✅',
    competitor: 'Email sequences only'
  }, {
    feature: 'No learning curve',
    mistr: '✅',
    competitor: '❌ (steep)'
  }, {
    feature: 'Dedicated phone lines per client',
    mistr: '✅',
    competitor: '❌'
  }, {
    feature: 'All-in-one pricing',
    mistr: '✅',
    competitor: '❌ (per seat + add-ons)'
  }]} whyMistrWins={[{
    title: 'Runs Your Whole Business',
    desc: 'Not just your pipeline. MR handles ops, support, and more.'
  }, {
    title: 'Self-Managing',
    desc: 'Zero manual data entry. MR updates itself from every interaction.'
  }, {
    title: 'One Flat Price',
    desc: 'No per-seat pricing that scales up as you grow.'
  }, {
    title: 'Voice-First',
    desc: 'Zero training needed. Just talk to MR.'
  }]} cantDoList={['Run your operations/projects/support', 'Answer your phone or manage calls', 'Update itself without manual data entry', 'Create content and manage PPC automatically', 'Work without extensive training and setup']} priceComparison={{
    competitorPrice: '$800/mo',
    competitorDesc: 'HubSpot Professional (5 seats, CRM + Marketing only)',
    mistrPrice: '$997/mo',
    mistrDesc: 'MR Pro (everything — CRM, PM, marketing, voice, website, operations)',
    note: "HubSpot Enterprise is $3,600/mo and still doesn't do what MR does."
  }} data-id="element-2874" />;
}